<form class="routed-component-layout" [formGroup]="form" novalidate>
  <div class="routed-component-body">

    <div class="routed-component-title-block">
      <h2>{{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.TITLE' | translate }}</h2>
      <h5>
        {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.INTRO_PREFIX' | translate }}
        <button class="link no-padding" type="button" (click)="enterManually()" data-cy="CompanySearch_Link_EnterManually">
          {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.ENTER_MANUALLY_LINK' | translate }}
        </button>.
      </h5>
    </div>

    <soldo-field-layout *ngIf="hasBothModes"
      [control]="form.controls['mode']"
      fieldName="mode"
      cypressSelector="CompanySearch_RadioGroup_Mode">

      <fieldset input>
        <div class="radio-item" data-cy="CompanySearch_Radio_ByName">
          <input type="radio" formControlName="mode" name="mode" id="modeByName" value="name">
          <label for="modeByName">{{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.MODE.NAME' | translate }}</label>
        </div>
        <div class="radio-item" data-cy="CompanySearch_Radio_ByNumber">
          <input type="radio" formControlName="mode" name="mode" id="modeByNumber" value="registrationNumber">
          <label for="modeByNumber">{{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.MODE.REG_NUMBER' | translate }}</label>
        </div>
      </fieldset>
    </soldo-field-layout>

    <soldo-field-layout
      [control]="form.controls['term']"
      fieldName="term"
      cypressSelector="CompanySearch_Input_Term">

      <div input>
        <div class="search-row">
          <input
            type="text"
            name="term"
            formControlName="term"
            [placeholder]="modeConfig?.placeholderKey | translate: { value: modeConfig?.placeholderParam }">

          <button type="submit" class="primary" (click)="search()" [ngClass]="{'loading': isLoading}" [disabled]="isLoading" data-cy="CompanySearch_Button_Search">
            {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.SEARCH_BTN' | translate }}
          </button>
        </div>
        @if (modeConfig?.hintKey) {
          <p data-cy="CompanySearch_Hint">
            {{ modeConfig.hintKey| translate }}
          </p>
        }
      </div>

      <ng-container errorMessage>
        <soldo-field-error errorName="minlength">{{ 'MIN_LENGTH' | translate: { value: form.get('term')?.errors?.minlength?.requiredLength } }}</soldo-field-error>
      </ng-container>
    </soldo-field-layout>


    <p class="loading-message loading-dots" *ngIf="isSearchLoading" data-cy="CompanySearch_Loading_Search">
      {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.LOADING.SEARCHING' | translate }}
    </p>
    <p class="loading-message loading-dots" *ngIf="isDownloadLoading" data-cy="CompanySearch_Loading_Download">
      {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.LOADING.DOWNLOADING' | translate }}
    </p>

    <p *ngIf="error === 'noResults'" data-cy="CompanySearch_Error_NoResults">
      {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.ERROR.NO_RESULTS' | translate: { term: searchedTerm } }}
    </p>
    <p *ngIf="error === 'invalidFormat'" data-cy="CompanySearch_Error_InvalidFormat">
      {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.ERROR.INVALID_FORMAT' | translate: { term: searchedTerm } }}
    </p>
    <p *ngIf="error === 'tooManyResults'" data-cy="CompanySearch_Error_TooManyResults">
      {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.ERROR.TOO_MANY_RESULTS' | translate }}
    </p>
    <p *ngIf="error === 'providerUnreachable'" data-cy="CompanySearch_Error_ProviderUnreachable">
      {{ 'REGISTRATION.COMPANY_STEP.COMPANY_SEARCH.ERROR.PROVIDER_UNREACHABLE' | translate }}
    </p>

    @if (!isLoading && results.length > 0) {
      <fieldset class="card-group-layout results-list" data-cy="CompanySearch_Result_Container">
        @for (result of results; track result.kybProviderId; let i = $index) {
          <label class="result-card card"
            (interact)="selectResult(result)"
            [attr.data-cy]="'CompanySearch_Result_' + i">
            <input type="radio" [id]="'CompanySearch_Result_' + i" [formControl]="form.controls.result" [value]="result.kybProviderId"/>

            <span class="result-name">{{ result.name }}</span>
            <span class="result-reg">{{ result.registrationNumber }}</span>
          </label>
        }
      </fieldset>
    }
  </div>

  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="previousStep()" data-cy="Signup_Button_PreviousStepButton">
        {{ 'REGISTRATION.COMPANY_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
      </button>
    </div>
    <save-and-continue-later stepName="Company Search"></save-and-continue-later>
  </div>
</form>
